const IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/avif',
  'image/svg+xml',
])

export default function (mimeType) {
  if (!mimeType) {
    return false
  }

  return IMAGE_MIME_TYPES.has(mimeType.toLowerCase())
}
